var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInsertLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4627_1308)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.227 19.773C9.21937 18.7654 9.21937 17.1272 10.227 16.1196L12.584 13.7626L11.4644 12.643L9.10741 15C7.48107 16.6264 7.48107 19.2662 9.10741 20.8926C10.7338 22.5189 13.3736 22.5189 15 20.8926L17.357 18.5355L16.2374 17.416L13.8804 19.773C12.8728 20.7806 11.2346 20.7806 10.227 19.773ZM13.2322 17.9463L17.9462 13.2322L16.7677 12.0537L12.0537 16.7678L13.2322 17.9463ZM15 9.10745L12.6429 11.4645L13.7625 12.5841L16.1196 10.227C17.1272 9.21941 18.7653 9.21941 19.7729 10.227C20.7806 11.2347 20.7806 12.8728 19.7729 13.8804L17.4159 16.2374L18.5355 17.357L20.8925 15C22.5189 13.3737 22.5189 10.7338 20.8925 9.10745C19.2662 7.48111 16.6263 7.48111 15 9.10745Z",
    fill: "url(#paint0_linear_4627_1308)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4627_1308",
    x1: 12.0537,
    y1: 12.0537,
    x2: 17.9462,
    y2: 17.9463,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#527BF2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41A0E5"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4627_1308"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0.85791 15) rotate(-45)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInsertLink);
export default __webpack_public_path__ + "static/media/insert-link.01b382c2e7de11a8413c456eb66cfd7f.svg";
export { ForwardRef as ReactComponent };